export class DocumentContact {
  id: number;
  address: any;
  address_id: number;
  contact_id: number;
  email_address: any;
  email_address_id: number;
  fax_number_id: number;
  involvement_id: number;
  copy_of_address: string;
  copy_of_contact: string;
  copy_of_email_address: string;
  copy_of_fax: string;
  send_by_mail: boolean = false;
  send_by_email: boolean = false;
  send_by_fax: boolean = false;
  send_attachments: boolean = true;
  type: string;
  created_at: string;
  updated_at: string;
  document_id: number;
  position: number;
  mail_type: string = 'basic';
  show_content: boolean = true;
  include_proof: boolean = false;
  show_attachments_edit: boolean = false;
  attachments: any = {};

  constructor(involvement: any, type: string) {
    this.involvement_id = involvement.id;
    this.contact_id = involvement.contact.id;
    this.copy_of_contact = involvement.contact.full_name;
    if (involvement.addresses.length > 0) {
      this.address = involvement.addresses[0];
      this.address_id = involvement.addresses[0].id;
      this.copy_of_address = involvement.addresses[0].full_address;
    }
    if (involvement.email_addresses.length > 0) {
      this.email_address = involvement.email_addresses[0];
      this.email_address_id = involvement.email_addresses[0].id;
      this.copy_of_email_address = involvement.email_addresses[0].email;
    }
    if (involvement.fax_number) {
      this.fax_number_id = involvement.fax_number.id;
      this.copy_of_fax = involvement.fax_number.number;
    }
    switch (type) {
      case 'To':
        this.type = 'DocumentToContact';
        if (involvement.addresses.length > 0) this.send_by_mail = true;
        break;
      case 'CC':
        this.type = 'DocumentCcContact';
        break;
      case 'BCC':
        this.type = 'DocumentBccContact';
        break;
    }
  }
}
